import {
  SOURCE_ADMIN_SMS,
  SOURCE_CITIZEN_LOCATION,
  SOURCE_RCS,
  SOURCE_SMS,
  SOURCE_TCAPI,
} from '@rsos/constants/locationSources';

const textBasedSources = new Set([
  SOURCE_SMS,
  SOURCE_RCS,
  SOURCE_TCAPI,
  SOURCE_ADMIN_SMS,
  SOURCE_CITIZEN_LOCATION,
]);

/**
 * @returns a boolean on whether or not the source is from text
 */
const isTextBasedSource = (source = '') => textBasedSources.has(source);

export default isTextBasedSource;
